import { IGroupMember } from "@app/types";
import React from "react";

export const DemoContent = ({
  groupData,
  children,
}: {
  groupData: IGroupMember;
  children: any;
}) => {
  return (
    <div className="distro-container">
      <p>
        {
          "Versiunea demo este disponibilă implicit și poate fi accesată fără restricții"
        }
      </p>
      <p>
        {
          "Este important de menționat că baza de date a versiunii demo este resetată periodic."
        }
      </p>
      <h2 className="someUnderline">
        {"Ajutor pentru Instalarea kitului de demo"}
      </h2>
      <em>{"Pe scurt:"}</em>
      <p>
        {
          'Descarcati fisierul de mai jos si rulati fisierul "setup.exe" pe PC-ul dvs. Veti gasi apoi un link pe desktop.'
        }
      </p>
      <em>{"Detalii:"}</em>
      <p>
        {"Pasii de urmat pentru instalare, ii gasiti detaliati "}
        <a
          href="https://help.jurnalgold.ro/Fluxul%20clasic/Instalarea%20versiunii%20demo#obtinerea-versiunii-demo"
          target="help"
          rel=""
        >
          {"pe pagina de ajutor - pct 3, 4, 5"}
        </a>
      </p>

      <h2 className="someUnderline">
        {"Descarcati kitul pentru Jurnal Gold Demo"}
      </h2>

      {children}
      <br />
      <h2 className="someUnderline">{"Utilizarea Jurnal Gold Demo"}</h2>
      <p>
        <b>
          {
            "Pentru accesul in aplicatie folositi acelasi USERNAME si PAROLA ca si cele cu care v-ati logat acest site."
          }
        </b>
      </p>
      <p>
        {
          "Detalii referitoare la principalele functionalitati, accesati pagina "
        }
        <a
          href="https://help.jurnalgold.ro/category/fluxul-clasic-de-lucru"
          target="help"
          rel=""
        >
          {" din ghidul Jurnal Gold"}
        </a>
      </p>
      <p>
        {
          "Sperăm că aceste instrucțiuni vă vor fi de ajutor și vă vor permite să explorați aplicația. Daca intampinati probleme, va rugam sa ne contactati"
        }
        <a
          href="https://www.jurnalgold.ro/contact/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {" aici"}
        </a>
        {"."}
      </p>
    </div>
  );
};
